// 保留两位小数
export const toFixed = {
  inserted(el, binding, vnode) {
    const scale = binding.value;

    setTimeout(() => {
      // 多种选择器尝试找到input元素，优先找number类型的
      let input = el.querySelector('input[type="number"]');
      if (!input) {
        // 找到所有.el-input__inner，排除select中的
        const inputs = el.querySelectorAll('.el-input__inner');
        for (let i = 0; i < inputs.length; i++) {
          if (inputs[i].tagName === 'INPUT') {
            input = inputs[i];
            break;
          }
        }
      }
      if (!input) {
        input = el.querySelector('input');
      }

      if (!input) {
        return;
      }

      input.addEventListener('blur', function () {
        let value = input.value;
        if (!isNaN(value) && value !== '') {
          const numValue = Number(value);
          const actualScale = Math.max(scale || 0, 2);
          // 如果是整数，直接使用整数值，不保留小数
          const formattedValue = Number.isInteger(numValue) ? String(numValue) : numValue.toFixed(actualScale);
          input.value = formattedValue;
          input.dispatchEvent(new Event('input', { bubbles: true }));
        }
      });
    }, 0);
  },
  update(el, binding) {
    // update时不需要重新绑定事件
  },
};
// 限制最大字节
export const byteLimit = {
  inserted(el, binding, vnode) {
    console.log('aaa');
    el.maxBytes = binding.value; // 最大字节数
    el.addEventListener('blur', () => {
      const text = el.value;
      const bytes = new Blob([text]).size; // 计算字节长度
      console.log(bytes);
      if (bytes > el.maxBytes) {
        // 如果超过最大字节数，则截断文本
        el.value = text.substring(0, text.length - 1);
        // 触发输入框的input事件，使v-model更新
        input.dispatchEvent(new Event('input'));
      }
    });
  },
};
